import { getErrorMessage } from "../shared/utils";
import axios from "axios";

import * as apiEndPoints from "../shared/apiPaths";
import * as actionTypes from "../components/matterSearch/actionTypes";
import * as caseSearchActionTypes from "./actionTypes";

export const getMatters = (showClosedMatters, token) => {
  return dispatch => {
    dispatch(getMattersRequest());

    const url = window.ENV.API_ROOT + apiEndPoints.SEARCH;

    const data = {
      ShowClosedMatters: showClosedMatters
    };

    const config = {
      headers: { Authorization: token.token }
    };

    axios
      .post(url, data, config)
      .then(response => {
        dispatch(getMattersSuccess(response.data));
      })
      .catch(error => {
        dispatch(getMattersFailure(getErrorMessage(error)));
      });
  };
};

export const setShowClosedMatterFlag = (showClosedMatters) => {
  return {
    type: caseSearchActionTypes.SET_ARCHIVE,
    showClosedMatters: showClosedMatters
  };
};

export const onSearch = (isSearched) => {
  return {
    type: caseSearchActionTypes.SET_SEARCH,
    isSearched: isSearched
  };
};

const getMattersRequest = () => {
  return {
    type: actionTypes.MATTER_SEARCH_REQUEST
  };
};

const getMattersFailure = error => {
  return {
    type: actionTypes.MATTER_SEARCH_FAILURE,
    error: error
  };
};

const getMattersSuccess = response => {
  return {
    type: actionTypes.MATTER_SEARCH_SUCCESS,
    response: response
  };
};
